import { render, staticRenderFns } from "./RevenueDefaultPricingTable.vue?vue&type=template&id=47ce1662&scoped=true&"
import script from "./RevenueDefaultPricingTable.vue?vue&type=script&lang=js&"
export * from "./RevenueDefaultPricingTable.vue?vue&type=script&lang=js&"
import style0 from "./RevenueDefaultPricingTable.vue?vue&type=style&index=0&id=47ce1662&lang=scss&scoped=true&"
import style1 from "./RevenueDefaultPricingTable.vue?vue&type=style&index=1&lang=css&"
import style2 from "./RevenueDefaultPricingTable.vue?vue&type=style&index=2&id=47ce1662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce1662",
  null
  
)

export default component.exports